function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
export const shadow2xl = process.env.NODE_ENV === "production" ? {
  name: "1uej07o",
  styles: "box-shadow:0 25px 50px -12px #00000040"
} : {
  name: "ry7z6g-shadow2xl",
  styles: "box-shadow:0 25px 50px -12px #00000040;label:shadow2xl;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const shadowXl = process.env.NODE_ENV === "production" ? {
  name: "64ga33",
  styles: "box-shadow:0 20px 25px -5px #0000001a, 0 10px 10px -5px #0000000a"
} : {
  name: "iggogq-shadowXl",
  styles: "box-shadow:0 20px 25px -5px #0000001a, 0 10px 10px -5px #0000000a;label:shadowXl;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const shadowLg = process.env.NODE_ENV === "production" ? {
  name: "mfmz6l",
  styles: "box-shadow:0 10px 15px -3px #0000001a, 0 4px 6px -2px #0000000d"
} : {
  name: "1u3p76v-shadowLg",
  styles: "box-shadow:0 10px 15px -3px #0000001a, 0 4px 6px -2px #0000000d;label:shadowLg;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const shadowMd = process.env.NODE_ENV === "production" ? {
  name: "1v88h9h",
  styles: "box-shadow:0 4px 6px -1px #0000001a, 0 2px 4px -1px #0000000f"
} : {
  name: "1iibwr6-shadowMd",
  styles: "box-shadow:0 4px 6px -1px #0000001a, 0 2px 4px -1px #0000000f;label:shadowMd;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const shadowSm = process.env.NODE_ENV === "production" ? {
  name: "1xakdx0",
  styles: "box-shadow:0 1px 2px 0 #0000000d"
} : {
  name: "1fzgwit-shadowSm",
  styles: "box-shadow:0 1px 2px 0 #0000000d;label:shadowSm;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const shadowHighlighted = process.env.NODE_ENV === "production" ? {
  name: "1bmdbu4",
  styles: "box-shadow:0px 0px 12px #0000001f"
} : {
  name: "1uol39m-shadowHighlighted",
  styles: "box-shadow:0px 0px 12px #0000001f;label:shadowHighlighted;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const shadow = process.env.NODE_ENV === "production" ? {
  name: "jriiq3",
  styles: "box-shadow:0 1px 3px 0 #0000001a, 0 1px 2px 0 #0000000f"
} : {
  name: "s0k07j-shadow",
  styles: "box-shadow:0 1px 3px 0 #0000001a, 0 1px 2px 0 #0000000f;label:shadow;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};